const langs = [
  {
    label: 'Arabic',
    value: 'ar',
    auto: false,
  },
  {
    label: 'Chinese (Simplified)',
    value: 'zh-CN',
    auto: false,
  },
  {
    label: 'Chinese (Traditional)',
    value: 'zh-TW',
    auto: false,
  },
  {
    label: 'Czech',
    value: 'cs',
    auto: false,
  },
  {
    label: 'Danish',
    value: 'da',
    auto: false,
  },
  {
    label: 'Dutch',
    value: 'nl',
    auto: false,
  },
  {
    label: 'English',
    value: 'en',
    auto: true,
  },
  {
    label: 'Finnish',
    value: 'fi',
    auto: false,
  },
  {
    label: 'French',
    value: 'fr',
    auto: false,
  },
  {
    label: 'German',
    value: 'de',
    auto: false,
  },
  {
    label: 'Greek',
    value: 'el',
    auto: false,
  },
  {
    label: 'Hebrew',
    value: 'he',
    auto: false,
  },
  {
    label: 'Icelandic',
    value: 'is',
    auto: false,
  },
  {
    label: 'Italian',
    value: 'it',
    auto: false,
  },
  {
    label: 'Japanese',
    value: 'ja',
    auto: false,
  },
  {
    label: 'Korean',
    value: 'ko',
    auto: false,
  },
  {
    label: 'Norwegian Bokmål',
    value: 'nb',
    auto: false,
  },
  {
    label: 'Polish',
    value: 'pl',
    auto: false,
  },
  {
    label: 'Portuguese',
    value: 'pt',
    auto: false,
  },
  {
    label: 'Portuguese - Brazil',
    value: 'pt-BR',
    auto: false,
  },
  {
    label: 'Portuguese - Portugal',
    value: 'pt-PT',
    auto: false,
  },
  {
    label: 'Russian',
    value: 'ru',
    auto: false,
  },
  {
    label: 'Spanish',
    value: 'es',
    auto: true,
  },
  {
    label: 'Swedish',
    value: 'sv',
    auto: false,
  },
  {
    label: 'Thai',
    value: 'th',
    auto: false,
  },
  {
    label: 'Turkish',
    value: 'tr',
    auto: false,
  },
  {
    label: 'Vietnamese',
    value: 'vi',
    auto: false,
  },
]

export default langs
  